import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { SettingsNames } from '@/widgets/sidebar'

import { useUserFeatures } from '@/shared/composables/user-features'
import { FeaturesNames } from '@/shared/types/settings'
import { pathNames } from '@/shared/utils/constants'


export const blackWhiteListBeforeEnter = (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): void => {
  const { hasFeature } = useUserFeatures()
  if (!hasFeature(FeaturesNames.BLACK_WHITE_LIST)) {
    const isSupport = to.name === pathNames.SUPPORT_SETTINGS_BLACK_WHITE_LIST
    next({ name: isSupport ? pathNames.SUPPORT_SETTINGS_CALLS : SettingsNames.calls })
    return
  }
  next()
}
